import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.25 6C10.25 5.58579 10.5858 5.25 11 5.25H20C20.4142 5.25 20.75 5.58579 20.75 6C20.75 6.41421 20.4142 6.75 20 6.75H11C10.5858 6.75 10.25 6.41421 10.25 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.25 12C10.25 11.5858 10.5858 11.25 11 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H11C10.5858 12.75 10.25 12.4142 10.25 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.25 18C10.25 17.5858 10.5858 17.25 11 17.25H20C20.4142 17.25 20.75 17.5858 20.75 18C20.75 18.4142 20.4142 18.75 20 18.75H11C10.5858 18.75 10.25 18.4142 10.25 18Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.5 5.25C5.08579 5.25 4.75 5.58579 4.75 6C4.75 6.41421 5.08579 6.75 5.5 6.75C5.91421 6.75 6.25 6.41421 6.25 6C6.25 5.58579 5.91421 5.25 5.5 5.25ZM3.25 6C3.25 4.75736 4.25736 3.75 5.5 3.75C6.74264 3.75 7.75 4.75736 7.75 6C7.75 7.24264 6.74264 8.25 5.5 8.25C4.25736 8.25 3.25 7.24264 3.25 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.5 11.25C5.08579 11.25 4.75 11.5858 4.75 12C4.75 12.4142 5.08579 12.75 5.5 12.75C5.91421 12.75 6.25 12.4142 6.25 12C6.25 11.5858 5.91421 11.25 5.5 11.25ZM3.25 12C3.25 10.7574 4.25736 9.75 5.5 9.75C6.74264 9.75 7.75 10.7574 7.75 12C7.75 13.2426 6.74264 14.25 5.5 14.25C4.25736 14.25 3.25 13.2426 3.25 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.5 17.35C5.08579 17.35 4.75 17.6858 4.75 18.1C4.75 18.5142 5.08579 18.85 5.5 18.85C5.91421 18.85 6.25 18.5142 6.25 18.1C6.25 17.6858 5.91421 17.35 5.5 17.35ZM3.25 18.1C3.25 16.8574 4.25736 15.85 5.5 15.85C6.74264 15.85 7.75 16.8574 7.75 18.1C7.75 19.3426 6.74264 20.35 5.5 20.35C4.25736 20.35 3.25 19.3426 3.25 18.1Z",
			fill: "currentColor"
		})
	]
});
export default SvgList;
